import { Skeleton } from "@/components/ui/skeleton";

import { type CalendarView } from "../types";

// =============================================================================

type CalendarSkeletonProps = {
  view: CalendarView;
  hourCount: number;
  /** Month cells are taller with an addon line */
  hasDayAddon: boolean;
};

/**
 * Placeholder of the first server render: the grid depends on the browser's
 * time zone, so it is only drawn once hydrated. Sized like the view to avoid
 * a layout shift (a 5-week month; the root's max height bounds the week).
 */
export function CalendarSkeleton({
  view,
  hourCount,
  hasDayAddon,
}: CalendarSkeletonProps) {
  const height =
    view === "week"
      ? `calc(3.5rem + ${hourCount} * var(--calendar-hour-height))`
      : hasDayAddon
        ? "42.5rem"
        : "37rem";

  return (
    <div aria-hidden className="p-3" style={{ height }}>
      <Skeleton className="size-full rounded-lg bg-surface-2/70 motion-reduce:animate-none" />
    </div>
  );
}
